/**
 * dir-w | backOffice
 * 404 Page Not Found
 *
 * Last update : January 10, 2024 | @rizkiprasetya
 */

import { Component } from '@angular/core';
import { Configuration } from '../../config/configuration';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrl: './page-not-found.component.css',
    standalone: false
})
export class PageNotFoundComponent {
  protected profilePath: string = `/assets/profile/${Configuration.Profile}/images/background.png`;
}
